import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { inject } from '@angular/core';
import { map } from 'rxjs';
import { LocationStrategy } from '@angular/common';
import { WatcherService } from '../services/watcher.service';

export const VerificationGuard: CanActivateFn = (route, state) => {
  const store = inject(Store)
  const router = inject(Router)
  const _location = inject(LocationStrategy)
  const _watcherService = inject(WatcherService);
  let _lang = 'en';
  _watcherService.getLang().subscribe(lang => {
    _lang = lang;
  })
  return store.select('auth').pipe(
    map(authRes => {
      const user = authRes.user;
      switch (user['is_email_verified']) {
        case true:
          if (user['is_phone_verified']) {
            return true;
          } else {
            router.navigateByUrl(`/${_lang}/verification`);
            return false;
          }
        case 1:
          if (user['is_phone_verified']) {
            return true;
          } else {
            router.navigateByUrl(`/${_lang}/verification`);
            return false;
          }
        default:
          router.navigateByUrl(`/${_lang}/verification`);
          return false;
      }
    })
  )
}
